export function canDevBeManaged(ostype) {
  return (
    ostype === MACROS.DVM.DVM_OS_TYPE_FOS ||
    ostype === MACROS.DVM.DVM_OS_TYPE_FOC ||
    ostype === MACROS.DVM.DVM_OS_TYPE_FFW ||
    ostype === MACROS.DVM.DVM_OS_TYPE_FWC ||
    ostype === MACROS.DVM.DVM_OS_TYPE_FPX
  );
}
